import { render, staticRenderFns } from "./MlbNews.vue?vue&type=template&id=cea05734&scoped=true"
import script from "./MlbNews.vue?vue&type=script&lang=js"
export * from "./MlbNews.vue?vue&type=script&lang=js"
import style0 from "./MlbNews.vue?vue&type=style&index=0&id=cea05734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea05734",
  null
  
)

export default component.exports